module.exports = __webpack_public_path__ + "static/media/stars-bg.68ee87ee.svg";